import { JsonProperty } from 'json-typescript-mapper';
import { User } from './user.model';
import { Contact } from './contact.model';

export class DeviceRefund {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('validFrom')
  public validFrom?: string;

  @JsonProperty('marketdateRefund')
  public marketdateRefund?: number;

  @JsonProperty('refundPerMerchant')
  public refundPerMerchant?: number;

  @JsonProperty('user')
  public user?: User;

  @JsonProperty('created')
  public created?: string;

  @JsonProperty('createdBy')
  public createdBy?: Contact;

  @JsonProperty('comment')
  public comment?: string;

  constructor() {
    this.id = void 0;
    this.validFrom = void 0;
    this.marketdateRefund = void 0;
    this.refundPerMerchant = void 0;
    this.user = void 0;
    this.created = void 0;
    this.createdBy = void 0;
    this.comment = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/device-refund.model.ts